/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { UserX, Info } from 'lucide-react';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import ConfirmDialog from '../../components/ConfirmDialog';

function DeleteMemberConfirmationModal({ closeModal, getMembers, member }) {
  const { activeWorkspace } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [submitting, setSubmitting] = useState(false);

  const handleDeleteMember = async () => {
    setSubmitting(true);
    const response = await sendRequest({
      method: 'put',
      url: API.WORKSPACE.deactivateMember(activeWorkspace.id, member.id),
    });
    if (response.success) {
      const name = member?.user?.firstName && member?.user?.lastName
        ? `${member.user.firstName} ${member.user.lastName}`
        : member.user.email;
      displayNotification({ message: `Deactivated ${name}`, severity: 'success' });
      getMembers();
      closeModal();
    } else {
      displayNotification({
        message: response?.data?.error || 'Something went wrong. Please try again.',
        severity: 'error',
      });
      setSubmitting(false);
    }
  };

  return (
    <ConfirmDialog
      tone="danger"
      icon={<UserX size={24} />}
      title="Delete Workspace Member"
      description="After you deactivate the account the user will no longer be able to log in to the workplace."
      confirmLabel="Deactivate"
      cancelLabel="Cancel"
      confirming={submitting}
      onConfirm={handleDeleteMember}
      onCancel={closeModal}
    >
      <div
        className="flex items-center gap-2 rounded-[8px]"
        style={{
          backgroundColor: '#e8eef7', color: '#4062E5', padding: '8px 12px', fontSize: 13,
        }}
        data-testid="info-section"
      >
        <Info size={16} style={{ flexShrink: 0 }} />
        User will no longer be able to log in to the workplace.
      </div>
    </ConfirmDialog>
  );
}

DeleteMemberConfirmationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  getMembers: PropTypes.func.isRequired,
  member: PropTypes.shape({
    id: PropTypes.number.isRequired,
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }).isRequired,
    activity: PropTypes.shape({}),
  }).isRequired,
};

export default DeleteMemberConfirmationModal;
